import { Stack } from '@fluentui/react';
import { Text } from '@fluentui/react-components';
import { CloudError32Filled } from '@fluentui/react-icons';
import { FC } from 'react';

const ErrorScreen: FC<{ message: string }> = ({ message }) => (
	<Stack className={'stackPanel'} tokens={{ childrenGap: 20 }}>
		<Stack.Item>
			<CloudError32Filled />
		</Stack.Item>
		<Stack.Item>
			<Text size={400} weight={'medium'}>
				{message}
			</Text>
		</Stack.Item>
	</Stack>
);

export default ErrorScreen;
